import i18n, { type Resource } from 'i18next';
import { initReactI18next } from 'react-i18next';

/** Initialize i18next with bundled translation resources. */
export function initI18n(resources: Resource) {
  void i18n.use(initReactI18next).init({
    lng: 'en',
    fallbackLng: false,
    returnEmptyString: false,
    ns: ['common', 'errors'],
    // biome-ignore lint/style/useNamingConvention: i18next config property
    defaultNS: 'common',
    // biome-ignore lint/style/useNamingConvention: i18next config property
    fallbackNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    resources,
  });
}

export { i18n };
